module.exports = __webpack_public_path__ + "static/pic11-92f181599c354eb19d73cce4c90d1858.jpg";